import React from 'react';
const Footer = () => {
  return <footer className="px-3 sm:px-4 md:px-8 py-5 sm:py-6 text-xs text-gray-500 border-t border-gray-200 bg-gray-50" data-id="element-213">
      <div className="max-w-4xl mx-auto" data-id="element-214">
        <p className="mb-3 sm:mb-4 leading-relaxed" data-id="element-215">
          This is an advertisement and not an actual news article, blog, or
          consumer protection update. Individual results may vary. These
          statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease.
        </p>
        <div className="flex flex-wrap gap-x-3 sm:gap-x-4 gap-y-1 mb-3 sm:mb-4" data-id="element-216">
          <span className="hover:text-gray-700 cursor-pointer" data-id="element-217">About Us</span>
          <span data-id="element-218">|</span>
          <span className="hover:text-gray-700 cursor-pointer" data-id="element-219">
            Terms of Use
          </span>
          <span data-id="element-220">|</span>
          <span className="hover:text-gray-700 cursor-pointer" data-id="element-221">
            Privacy Policy
          </span>
          <span data-id="element-222">|</span>
          <span className="hover:text-gray-700 cursor-pointer" data-id="element-223">
            Do Not Sell My Personal Information
          </span>
        </div>
        <p className="mb-3 sm:mb-4 leading-relaxed" data-id="element-224">
          Trademarks utilized on our website belong to their respective owners
          and no implied or expressed endorsement of our website or services is
          intended. Through in-depth research and experienced editors we provide
          feedback about products and services. We are independently owned, and
          opinions expressed here are our own. This website is an independent
          professional comparison and review site supported by referral fees
          from the sites and products featured.
        </p>
        <p data-id="element-225">©2025 HealthWellness Insights. All Rights Reserved.</p>
      </div>
    </footer>;
};
export default Footer;